/* ============================================================
   SANO.PT - Conversion & Compliance Core v15.1
   Ficheiro: assets/sano-v2.js

   Objetivo:
   - Manter estabilizacao PDP / cart / Marinus / collections.
   - CTA publico unico: 243 250 071 (click-to-call sticky).
   - Portes consistentes: envio gratis acima de 49€.
   - Upsell Pack 3 no cart so se Pack 3 ainda nao esta no carrinho.
   - Corrigir widget comparacao Pack 3 (€79,90 fantasma → €69,90).
   - Copy comercial sem claims medicas.
   - Nao mexer no checkout Shopify.
   ============================================================ */

(function () {
  "use strict";

  var SANO = {
    navy: "#071b4f",
    blue: "#243f99",
    green: "#34a853",
    gold: "#d6aa32",
    border: "#e6eef8",
    soft: "#f7fbff",
    phoneDisplay: "243 250 071",
    phoneTel: "+351243250071",
    pack3Path: "/products/creme-sano-tratamento-completo-pack-3",
    pack3Handle: "creme-sano-tratamento-completo-pack-3"
  };

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function addStyle(id, css) {
    if (document.getElementById(id)) return;
    var style = document.createElement("style");
    style.id = id;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function isPath(regex) {
    return regex.test(window.location.pathname);
  }

  function walkText(root, callback) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      callback(node);
    }
  }

  function normalizeText() {
    var replacements = [
      [/Continuar comprando/g, "Continuar a comprar"],
      [/CONTINUAR COMPRANDO/g, "CONTINUAR A COMPRAR"],
      [/Finalizar compra/g, "Finalizar encomenda"],
      [/FINALIZAR COMPRA/g, "FINALIZAR ENCOMENDA"],
      [/Métodos de Pagamentos/g, "Métodos de Pagamento"],
      [/Dicas semanais de saúde articular/g, "Dicas semanais de bem-estar"],
      [/DICAS SEMANAIS DE SAÚDE ARTICULAR/g, "DICAS SEMANAIS DE BEM-ESTAR"],
      [/Gaste mais/g, "Adicione mais"],
      [/Envio Grátis Para Portugal/g, "Envio grátis acima de 49€"],
      [/Envio grátis para Portugal Continental/g, "Envio grátis acima de 49€ (Portugal Continental)"],
      [/Envio Grátis para Portugal/g, "Envio grátis acima de 49€"],
      [/ENVIO GRÁTIS EM PORTUGAL CONTINENTAL/g, "ENVIO GRÁTIS ACIMA DE 49€"],
      [/249\s*105\s*081/g, SANO.phoneDisplay],
      [/249\s*10\s*50\s*81/g, SANO.phoneDisplay]
    ];

    walkText(document.body, function (node) {
      var text = node.nodeValue;
      if (!text || !text.trim()) return;
      replacements.forEach(function (pair) {
        text = text.replace(pair[0], pair[1]);
      });
      if (text !== node.nodeValue) node.nodeValue = text;
    });
  }

  function fixPack3ComparePrice() {
    walkText(document.body, function (node) {
      var t = node.nodeValue;
      if (!t) return;
      var next = t
        .replace(/€79,90/g, "€69,90")
        .replace(/€26,63\s*\/\s*unidade/g, "€23,30 / unidade")
        .replace(/Poupa €39,80 vs 3× Pack 1/g, "Poupa €49,80 vs 3× Pack 1")
        .replace(/Poupa €39,80 vs 3x Pack 1/g, "Poupa €49,80 vs 3× Pack 1");
      if (next !== t) node.nodeValue = next;
    });
  }

  function injectStickyPhone() {
    if (document.getElementById("sano-sticky-phone-v15")) return;

    addStyle("sano-sticky-phone-css-v15", [
      "#sano-sticky-phone-v15{position:fixed;left:0;right:0;bottom:0;z-index:99999;display:flex;gap:8px;padding:10px 12px calc(10px + env(safe-area-inset-bottom));background:rgba(7,27,79,.97);box-shadow:0 -8px 24px rgba(7,27,79,.25);}",
      "#sano-sticky-phone-v15 a{flex:1;display:flex;align-items:center;justify-content:center;min-height:48px;border-radius:8px;font-weight:800;font-size:15px;text-decoration:none!important;}",
      "#sano-sticky-phone-v15 .sano-call{background:" + SANO.green + ";color:#fff!important;}",
      "#sano-sticky-phone-v15 .sano-pack{background:" + SANO.gold + ";color:" + SANO.navy + "!important;}",
      "body.sano-has-sticky-phone{padding-bottom:76px!important;}",
      "@media(min-width:990px){#sano-sticky-phone-v15{left:auto;right:20px;bottom:20px;width:360px;border-radius:12px;padding:12px;}}"
    ].join(""));

    var bar = document.createElement("div");
    bar.id = "sano-sticky-phone-v15";
    bar.innerHTML =
      '<a class="sano-call" href="tel:' + SANO.phoneTel + '">Ligar ' + SANO.phoneDisplay + "</a>" +
      '<a class="sano-pack" href="' + SANO.pack3Path + '">Pack 3 — 69,90€</a>';
    document.body.appendChild(bar);
    document.body.classList.add("sano-has-sticky-phone");
  }

  function stabilizeProductPages() {
    if (!isPath(/^\/products\//)) return;

    addStyle("sano-product-core-v15", [
      ".product-form,.product-meta,.product-block-list__item{max-width:100%;}",
      ".product-form__payment-container{display:grid!important;gap:10px!important;position:relative!important;z-index:1!important;}",
      ".product-form__payment-container button,.shopify-payment-button__button{width:100%!important;min-height:54px!important;margin:0!important;position:relative!important;z-index:1!important;}",
      ".shopify-payment-button{display:block!important;margin-top:0!important;position:relative!important;z-index:1!important;}",
      ".shopify-payment-button__more-options{display:block!important;margin-top:10px!important;position:relative!important;z-index:1!important;}",
      ".sano-trust-strip{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin:14px 0;padding:12px;background:#f4fff7;border:1px solid #ccebd4;border-radius:8px;color:#154c28;font-weight:700;font-size:12px;line-height:1.35;}",
      ".sano-guarantee-box{margin:14px 0;padding:16px;border-radius:8px;background:" + SANO.blue + ";color:#fff;line-height:1.45;position:relative;z-index:1;}",
      ".sano-guarantee-box strong{display:block;font-size:14px;margin-bottom:4px;}",
      ".sano-guarantee-box span{display:block;font-size:12px;opacity:.95;}",
      ".sano-phone-inline{margin:12px 0 0;padding:12px 14px;border-radius:8px;border:1px solid " + SANO.border + ";background:" + SANO.soft + ";}",
      ".sano-phone-inline a{color:" + SANO.navy + ";font-weight:800;font-size:16px;text-decoration:none!important;}",
      ".sano-phone-inline small{display:block;margin-top:4px;color:#536078;font-size:12px;}",
      "@media(max-width:749px){.sano-trust-strip{grid-template-columns:1fr;font-size:12px}.product-form__payment-container button,.shopify-payment-button__button{min-height:52px!important}}"
    ].join(""));

    var payment = document.querySelector(".product-form__payment-container");
    if (!payment) return;

    if (!document.getElementById("sano-trust-strip-v15")) {
      var strip = document.createElement("div");
      strip.id = "sano-trust-strip-v15";
      strip.className = "sano-trust-strip";
      strip.innerHTML =
        "<div>Garantia 30 dias</div>" +
        "<div>Envio grátis acima de 49€</div>" +
        "<div>Qualidade garantida desde 2011</div>";
      payment.parentNode.insertBefore(strip, payment.nextSibling);
    }

    if (!document.getElementById("sano-guarantee-box-v15")) {
      var box = document.createElement("div");
      box.id = "sano-guarantee-box-v15";
      box.className = "sano-guarantee-box";
      box.innerHTML =
        "<strong>Garantia de Satisfação 30 Dias</strong>" +
        "<span>Se não ficar satisfeito por qualquer motivo, devolvemos o valor total. Sem perguntas, sem burocracia.</span>";
      payment.parentNode.insertBefore(box, payment.nextSibling);
    }

    if (!document.getElementById("sano-phone-inline-v15")) {
      var phone = document.createElement("div");
      phone.id = "sano-phone-inline-v15";
      phone.className = "sano-phone-inline";
      phone.innerHTML =
        '<a href="tel:' + SANO.phoneTel + '">Preferir falar? ' + SANO.phoneDisplay + "</a>" +
        "<small>Segunda a sexta, 9h–18h · Atendimento SANO</small>";
      payment.parentNode.insertBefore(phone, payment.nextSibling);
    }
  }

  function fixMarinus() {
    if (!isPath(/\/products\/marinus-sea-superfood-em-capsulas/)) return;

    document.body.classList.add("sano-marinus-page-v15");

    addStyle("sano-marinus-v15", [
      ".sano-marinus-page-v15 .product-form__option-selector .block-swatch__item:empty{display:none!important;}",
      ".sano-marinus-page-v15 .variant-swatch:empty{display:none!important;}",
      ".sano-marinus-page-v15 .product-form__option-selector{margin-bottom:14px!important;}",
      ".sano-marinus-page-v15 .product-form__option-name{font-weight:700;color:" + SANO.navy + ";}",
      ".sano-marinus-page-v15 .sano-empty-variant{display:none!important;}"
    ].join(""));

    document.querySelectorAll(".product-form__option-selector, .product-form__option, label, div").forEach(function (el) {
      var text = (el.innerText || "").trim();
      var hasInput = !!el.querySelector("input[type='radio'], input[type='checkbox']");
      if (hasInput && text.length === 0) el.classList.add("sano-empty-variant");
    });
  }

  function cartHasPack3() {
    var html = document.body ? document.body.innerText : "";
    if (/Creme Sano Pack 3|Pack 3 SANO|tratamento completo \(pack 3\)/i.test(html)) return true;
    var links = document.querySelectorAll('a[href*="creme-sano-tratamento-completo-pack-3"]');
    return links.length > 0 && !!document.querySelector(".cart, .cart-wrapper, .cart-page, form[action='/cart']");
  }

  function stabilizeCart() {
    if (!isPath(/^\/cart/)) return;

    document.body.classList.add("sano-cart-page-v15");

    addStyle("sano-cart-core-v15", [
      ".sano-cart-page-v15 *{box-sizing:border-box;}",
      ".sano-cart-page-v15 .cart,.sano-cart-page-v15 .cart-wrapper,.sano-cart-page-v15 .cart-page{max-width:1120px!important;margin-left:auto!important;margin-right:auto!important;}",
      ".sano-cart-page-v15 .cart__items,.sano-cart-page-v15 .cart__recap,.sano-cart-page-v15 .cart-recap{position:relative!important;left:auto!important;right:auto!important;top:auto!important;transform:none!important;z-index:1!important;}",
      ".sano-cart-page-v15 .line-item,.sano-cart-page-v15 .cart-item{position:relative!important;min-height:0!important;overflow:visible!important;}",
      ".sano-cart-page-v15 .quantity-selector,.sano-cart-page-v15 .quantity-selector__button,.sano-cart-page-v15 .quantity-selector__value{position:relative!important;z-index:1!important;}",
      ".sano-cart-page-v15 .cart__checkout-button,.sano-cart-page-v15 [name='checkout'],.sano-cart-page-v15 .button--primary{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:52px!important;margin:10px 0!important;position:relative!important;z-index:1!important;clear:both!important;}",
      ".sano-cart-page-v15 .sano-cart-upsell{margin:0 auto 24px;max-width:760px;padding:18px;border:1px solid " + SANO.border + ";border-radius:8px;background:" + SANO.soft + ";box-shadow:0 10px 30px rgba(7,27,79,.06);}",
      ".sano-cart-page-v15 .sano-cart-upsell strong{display:block;color:" + SANO.navy + ";font-size:16px;margin-bottom:6px;}",
      ".sano-cart-page-v15 .sano-cart-upsell p{margin:0 0 12px;color:#536078;}",
      ".sano-cart-page-v15 .sano-cart-upsell a{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 20px;border-radius:6px;background:" + SANO.navy + ";color:#fff!important;font-weight:700;text-decoration:none!important;}",
      "@media(max-width:749px){.sano-cart-page-v15 .cart,.sano-cart-page-v15 .cart-wrapper,.sano-cart-page-v15 .cart-page{max-width:100%!important;padding-left:16px!important;padding-right:16px!important}.sano-cart-page-v15 .sano-cart-upsell{margin:0 0 18px;padding:16px}.sano-cart-page-v15 .line-item,.sano-cart-page-v15 .cart-item{display:block!important}.sano-cart-page-v15 .quantity-selector{margin-top:10px!important}}"
    ].join(""));

    if (cartHasPack3()) {
      var old = document.getElementById("sano-cart-upsell-v15");
      if (old) old.remove();
      return;
    }

    var cartRoot =
      document.querySelector(".cart") ||
      document.querySelector(".cart-wrapper") ||
      document.querySelector("main");

    if (cartRoot && !document.getElementById("sano-cart-upsell-v15")) {
      var upsell = document.createElement("div");
      upsell.id = "sano-cart-upsell-v15";
      upsell.className = "sano-cart-upsell";
      upsell.innerHTML =
        "<strong>Melhor valor: Pack 3 SANO por 69,90 €</strong>" +
        "<p>Mais conforto por unidade. Envio grátis acima de 49€.</p>" +
        "<a href='" + SANO.pack3Path + "'>Ver Pack 3</a>";
      cartRoot.insertBefore(upsell, cartRoot.firstChild);
    }
  }

  function stabilizeCollections() {
    if (!isPath(/^\/collections\//)) return;

    addStyle("sano-collections-v15", [
      ".product-item,.product-card{min-height:0!important;overflow:visible!important;}",
      ".product-item__info,.product-card__info{display:block!important;min-height:0!important;}",
      ".product-item__title,.product-card__title{line-height:1.3!important;overflow-wrap:anywhere!important;}",
      ".price,.price-list{line-height:1.25!important;}",
      ".sano-free-shipping-badge{display:inline-flex;margin-top:8px;padding:5px 9px;border-radius:999px;background:#36d366;color:#fff;font-size:12px;font-weight:700;line-height:1.2;}"
    ].join(""));

    document.querySelectorAll(".sano-free-shipping-badge").forEach(function (badge) {
      badge.textContent = "Envio grátis acima de 49€";
    });

    document.querySelectorAll(".product-item, .product-card").forEach(function (card) {
      if (card.querySelector(".sano-free-shipping-badge")) return;
      var price = card.querySelector(".price, .price-list");
      if (!price) return;
      var badge = document.createElement("div");
      badge.className = "sano-free-shipping-badge";
      badge.textContent = "Envio grátis acima de 49€";
      price.parentNode.insertBefore(badge, price.nextSibling);
    });
  }

  function run() {
    normalizeText();
    fixPack3ComparePrice();
    injectStickyPhone();
    stabilizeProductPages();
    fixMarinus();
    stabilizeCart();
    stabilizeCollections();
  }

  ready(run);
  document.addEventListener("shopify:section:load", run);
  setTimeout(run, 500);
  setTimeout(run, 1500);
})();